import type { SitesSearch } from '@/routes/_protected/$tenantKey/settings/sites/-models'

import type { FetchSitesListQuery } from '../api'

export function buildFetchSitesQuery(
  tenantKey: string,
  deps: SitesSearch
): FetchSitesListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
